/* BOLDCURRENCY init */
if (typeof BOLDCURRENCY === 'undefined') {
    BOLDCURRENCY = {
        'currentCurrency': null,
        'defaultShopCurrency': '',
        'currencyCodesAndCountryCodes':{},
        'format' : 'money_format',
        'moneyFormats': {},
        'rateInfo': {},
        'geoLocate' : false,
        'currencyCookie': {
            configuration: {
                expires: 365,
                domain: window.location.hostname
            },
            write: function(currency) {
                var now = new Date();
                var time = now.getTime();
                time += 900 * 1000;
                now.setTime(time);

                document.cookie =
                    'boldCurrencyCookie=' + currency +
                    '; expires=' + now.toUTCString() + time +
                    '; path=/';
            },
            read: function() {
                var cookieValue = document.cookie.replace(/(?:(?:^|.*;\s*)boldCurrencyCookie\s*\=\s*([^;]*).*$)|^.*$/, "$1");
                return cookieValue;
            },
            destroy: function() {
                document.cookie = 'boldCurrencyCookie' + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
            }
        }
    };
}
